<template>
  <div class="client-list">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <b-card
            header-tag="header"
            footer-tag="footer">
            <div slot="header">
              <i className="fa fa-align-justify"></i><strong class="text-uppercase">{{ $t('permission.permissions') }}</strong>
              <div class="pull-right mr-4">
                <button type="button" class="btn btn-success right" @click="createUser"><i class="fa fa-plus"></i>&nbsp; {{$t('common.new')}}</button>
              </div>
            </div>
            <b-col cols="12" class="text-center">

              <!-- Start of Filter session -->
              <b-row>
                <b-col xl="8">
                  <b-input-group>
                    <select-dropdown v-bind:options="filter.options" v-bind:selected="filter.selected" position="prepend" v-bind:all="false" v-model="filter.field" prefix="permission">
                    </select-dropdown>
                    <b-form-input v-model="filter.key"></b-form-input>
                    <div class="input-group-append">
                      <b-input-group-append>
                        <b-btn @click="refreshData()"><i class="fa fa-search" ></i> {{$t('common.search')}}</b-btn>
                      </b-input-group-append>
                    </div>
                  </b-input-group>
                </b-col>
              </b-row>
              <!-- End of Filter session -->

              <!-- Start of Data table session -->
              <div class="table-responsive combo-data">
                <table class="table table-striped table-hover table-sm header-pointer">
                  <thead>
                  <tr>
                    <th scope="col" v-for="item in dataTable.fields" :key="item.id" @click="updateSort(item.name)">
                      <i class="fa fa-sort-amount-asc text-muted" v-if="dataTable.sort.type == 'asc' && dataTable.sort.field == item.name"></i>
                      <i class="fa fa-sort-amount-desc text-muted" v-if="dataTable.sort.type == 'desc' && dataTable.sort.field == item.name"></i>
                      <span v-if="item.label != null">{{$t('permission.'+item.label)}}</span>
                      <span v-if="item.label == null">{{$t('permission.'+item.name)}}</span>
                    </th>
                    <th scope="col">{{$t('common.action')}}</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-if="dataTable.items.length == 0">
                    <td class="text-center" :colspan="dataTable.fields.length + 1">
                      {{$t('message.no_data')}}
                    </td>
                  </tr>
                  <tr v-for="item in dataTable.items" :key="item.id">
                    <td scope="row" class="text-left" v-for="field in dataTable.fields" :key="field.id">
                      <span v-if="field.render != null" v-html="field.render(item[field.name], item)"></span>
                      <span v-if="field.render == null">
                        {{item[field.name]}}
                      </span>
                    </td>
                    <td scope="row" width="200">
                      <b-button size="sm" variant="primary" v-on:click="editItem(item.uuid)">
                        <i class="fa fa-edit"></i> {{$t('common.edit')}}
                      </b-button>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <!-- End of Data table session -->

              <!-- Start of paginate session -->
              <b-row>
                <b-col>
                  <b-pagination :total-rows="dataTable.total" :per-page="dataTable.perPage" v-model="dataTable.currentPage" />
                </b-col>
                <b-col class="text-left">
                  {{$t('message.datatable_total', {number: dataTable.items.length, total: dataTable.total})}}
                </b-col>
                <b-col col lg="1">
                  <b-form-select v-model="dataTable.perPage" :options="[10, 20, 50, 100]" class="mb-3"/>
                </b-col>
              </b-row>
              <!-- Start of paginate session -->

            </b-col>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
  import SelectDropdown from '../../../components/Partials/SelectDropdown'
  import DataTable from '../../../components/Partials/DataTable'
  import axios from 'axios'
  const CancelToken = axios.CancelToken
  let cancel = null
  let vm = null

  export default {
    name: 'UserList',
    components: {
      SelectDropdown,
      DataTable
    },
    data: function () {
      return {
        type: 'like',
        statuses: [],
        filter: {
          options: [],
          selected: null,
          active: "",
          field: null,
          key: null,
        },
        dataTable: {
          items: [],
          fields: [
            {
              name: 'name',
              filter: true,
              sort: true,
              render: (data, row) => {
                if (data == null) {
                  return ''
                }
                return data
              }
            }
          ],
          sort: {
            field: null,
            type: 'asc'
          },
          currentPage: 1,
          total: 0,
          perPage: 10,
          source: null
        },
        item: {}
      }
    },
    methods: {
      /**
       * update sort field and sort type then refresh data
       * @param field
       */
      updateSort (field) {
        for (let i in this.dataTable.fields) {
          if (this.dataTable.fields[i].name == field && (this.dataTable.fields[i].sort == null || this.dataTable.fields[i].sort == false)) {
            return
          }
        }
        if (this.dataTable.sort.field != field) {
          this.dataTable.sort = {
            field: field,
            type: 'asc'
          }
        } else {
          if (this.dataTable.sort.type == 'asc') {
            this.dataTable.sort = {
              field: field,
              type: 'desc'
            }
          } else {
            this.dataTable.sort = {
              field: field,
              type: 'asc'
            }
          }
        }

        this.refreshData()
      },
      /**
       * refresh data for data table
       */
      refreshData () {
        if (cancel != null) {
          cancel()
        }
        //get params
        let _data = {
          page: this.dataTable.currentPage,
          limit: this.dataTable.perPage,
          sort_field: this.dataTable.sort.field,
          sort_type: this.dataTable.sort.type,
        }
        if (!this._.isEmpty(this.filter.field) && !this._.isEmpty(this.filter.key)) {
          _data[this.filter.field] = this.filter.key.trim()
        }

        //process to send via get method
        let params = '';
        for (let key in _data) {
          params += key+'='+_data[key]+'&'
        }
        //remove tail
        params = params.slice(0, -1)
        vm.axios.user.getPermissionList('?' + params, function(response){
          vm.dataTable.items = response.data.data.items
          vm.dataTable.total = response.data.data.pagination.total
        })
      },
      editItem: function(uuid){
        vm.$router.push({name: 'permission_edit', params: { uuid: uuid }})
      },
      createUser: function(){
        vm.$router.push({name: 'permission_create', params: { id: 'create' }})
      },
    },
    created: function () {
      vm = this
      let CancelToken = vm.axios.CancelToken
      vm.dataTable.source = CancelToken.source()
      let allowedFilter = ['name', 'email']

      for (let i in vm.dataTable.fields) {
        let field = vm.dataTable.fields[i].name

        if (allowedFilter.includes(vm.dataTable.fields[i].name)
          && vm.dataTable.fields[i].filter != null
          && vm.dataTable.fields[i].filter == true) {
          vm.filter.options.push(vm.dataTable.fields[i])
        }
        if (vm.dataTable.fields[i].sort != null && vm.dataTable.fields[i].sort == true && vm.dataTable.sort.field == null) {
          vm.dataTable.sort = {
            field: field,
            type: 'asc'
          }
        }
      }
      vm.$Progress.start()
      vm.refreshData()
    },
    watch: {
      'dataTable.currentPage': function (val) {
        vm.refreshData()
      },
      'dataTable.perPage': function (val) {
        vm.refreshData()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/admin/permissions/List.vue